module.exports = __webpack_public_path__ + "media/images/MR_fingers-161991db.svg";